import styled from '@emotion/styled/macro';

export const PrizeDrawCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const PrizeDrawCardBox = styled.div`
    padding: ${props => (props.inPrizeDraw ? '35px' : '16px')} 16px 16px 16px;
    border-radius: 8px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
    background: #ffffff;
    min-width: 311px;
    width: 100%;
    @media (max-width: 320px) {
        min-width: auto;
        max-width: 98%;
    }
    margin: ${props => (props.InPrizeDraw ? '40px' : '24px')} 0
        ${props => props.theme.spacing.large} 0;
    text-align: center;
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    color: ${props => props.theme.colours.textDark};
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
`;

export const Heading = styled.h3`
    font-size: ${props => props.theme.fontSize.large};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-weight: 500;
    line-height: 24px;
    margin-bottom: ${props => props.theme.spacing.large};
`;

export const Text = styled.p`
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: 400;
    line-height: 22px;
    margin-bottom: ${props => props.theme.spacing.large};
`;

export const TextWithSmallerMargin = styled(Text)`
    margin-bottom: 12px;
`;

export const Highlighted = styled.span`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-weight: bold;
`;

export const XLink = styled.a`
    color: ${props => props.theme.colours.textOrange};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-weight: bold;
`;

export const Terms = styled.div`
    font-weight: 400;
    font-size: ${props => props.theme.fontSize.xsmall};
    line-height: 16px;
    color: ${props => props.theme.colours.textDark};
`;

export const TermsLink = styled(Terms)`
    text-decoration: underline;
    cursor: pointer;
`;
